import ReactGA from 'react-ga4';

const GaId = `G-${process.env.GA_ID}`;

const initGA = () => {
  ReactGA.initialize(GaId);
};

const logPageView = () => {
  if (!(window as unknown as { [x: string]: string }).GA_INITIALIZED) {
    initGA();
    (window as unknown as { [x: string]: string | boolean }).GA_INITIALIZED =
      true;
  }
  try {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname
    });
  } catch (error) {
    //
  }
};

const logEvent = (category = '', action = '', label = action) => {
  if (category && action && ReactGA) {
    try {
      ReactGA.event({ category, action, label });
    } catch (error) {
      //
    }
  }
};

export { initGA, logPageView, logEvent };
